export default __webpack_public_path__ + "static/media/logo-nuevo.7a28e65a.svg";